<div 
  class="custom-currency-modal" 
  *ngIf="isVisible"
  (keydown)="onKeyDown($event)"
  tabindex="0"
>
  <div class="modal-backdrop" (click)="onBackdropClick()"></div>
  <div class="modal-content">
    <div class="modal-header">
      <h3>{{ 'auth.createProject.addCustomCurrency' | translate }}</h3>
      <button type="button" class="close-btn" (click)="closeModal()">×</button>
    </div>
    
    <div class="modal-body">
      <div class="form-field">
        <label>{{ 'auth.createProject.currencyCode' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="newCurrency.shortName"
          placeholder="CAD"
          maxlength="3"
          (ngModelChange)="onCurrencyCodeChange()"
        />
        <small class="help-text">{{ 'auth.createProject.currencyCodeHelp' | translate }}</small>
      </div>

      <div class="validation-error" *ngIf="validationError">
        {{ validationError }}
      </div>
    </div>

    <div class="modal-footer">
      <button 
        type="button" 
        class="cancel-btn"
        (click)="closeModal()"
      >
        {{ 'common.cancel' | translate }}
      </button>
      <button 
        type="button" 
        class="add-btn"
        (click)="addCurrency()"
        [disabled]="!!validationError || !newCurrency.shortName.trim()"
      >
        {{ 'auth.createProject.addCurrency' | translate }}
      </button>
    </div>
  </div>
</div>
